import type { Decimal } from '~/composables/support/decimal'
import {
    inject,
    type InjectionKey,
    provide,
    readonly,
    type Ref,
    ref
} from 'vue'
import type { GiftCardPaymentInfo } from '~/components/Checkout/Sections/PaymentInformation.vue'

export type GiftCardDisplayData = {
    giftCardsToUse: GiftCardUsageData[]
    inputValue: string
    showClickApplyMessage: boolean
}

export type GiftCardUsageData = {
    id: string
    currentBalance: Decimal
    balanceToUse: Decimal
    code: string
}

const CheckoutGiftCardDataInjectionKey: InjectionKey<{
    giftCards: Readonly<Ref<GiftCardPaymentInfo[]>>
    updateGiftCards: (newValue: GiftCardPaymentInfo[]) => void
}> = Symbol('CheckoutGiftCardDataInjectionKey')

export function provideCheckoutGiftCardData() {
    const giftCards = ref<GiftCardPaymentInfo[]>([])

    provide(CheckoutGiftCardDataInjectionKey, {
        // @ts-ignore : I don't know why this is failing
        giftCards: readonly(giftCards),
        updateGiftCards: (newValue: GiftCardPaymentInfo[]) => {
            giftCards.value = newValue
        }
    })
}

export function useCheckoutGiftCards() {
    const data = inject(CheckoutGiftCardDataInjectionKey)
    if (data === undefined) {
        throw new Error('Must provide gift card display data')
    }

    return data.giftCards
}

export function useCheckoutUpdateGiftCards() {
    const data = inject(CheckoutGiftCardDataInjectionKey)
    if (data === undefined) {
        throw new Error('Must provide gift card display data')
    }

    return data.updateGiftCards
}
